import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e32d042"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xyp-page" }
const _hoisted_2 = { class: "xyp-hero" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Хэрэглэгч")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ХУР")
const _hoisted_6 = { class: "xyp-kicker" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Тусгай эрхтэй Монголбанкны хэрэглэгч ХУР сервисийг backend proxy-оор дамжуулан дуудна. ", -1))
const _hoisted_8 = { class: "xyp-status" }
const _hoisted_9 = {
  key: 0,
  class: "xyp-layout"
}
const _hoisted_10 = { class: "xyp-service-panel" }
const _hoisted_11 = { class: "xyp-service-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "xyp-workspace" }
const _hoisted_14 = { class: "xyp-search-band" }
const _hoisted_15 = { class: "xyp-section-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Хайх хэсэг", -1))
const _hoisted_17 = { class: "xyp-form-grid" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "xyp-actions" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Хайх ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Цэвэрлэх ")
const _hoisted_22 = { class: "xyp-result-band" }
const _hoisted_23 = {
  "element-loading-text": "ХУР сервисээс мэдээлэл авч байна...",
  "element-loading-spinner": "el-icon-loading",
  class: "xyp-result-loading-area"
}
const _hoisted_24 = { class: "xyp-section-title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Хариу мэдээлэл", -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "xyp-empty"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Сервис сонгоод хайлт хийнэ үү", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Хариу ирэхэд талбарууд автоматаар бүлэглэгдэж харагдана.", -1))
const _hoisted_31 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "xyp-result"
}
const _hoisted_33 = { class: "xyp-result-top" }
const _hoisted_34 = {
  key: 0,
  class: "xyp-photo"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Цээж зураг", -1))
const _hoisted_37 = { class: "xyp-result-summary" }
const _hoisted_38 = { class: "xyp-raw-response" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Техникийн raw response харах", -1))
const _hoisted_40 = {
  key: 1,
  class: "xyp-denied"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Хандах эрхгүй", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_xyp_value_renderer = _resolveComponent("xyp-value-renderer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_breadcrumb, {
          "separator-class": "el-icon-arrow-right",
          class: "xyp-breadcrumb"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.service.category) + " сервис", 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.service.code), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.xypRole(_ctx.service.code)), 1)
      ])
    ]),
    (_ctx.canAccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("aside", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.serviceSearch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serviceSearch) = $event)),
              "prefix-icon": "el-icon-search",
              clearable: "",
              size: "small",
              placeholder: "Сервис хайх..."
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedServices, (group) => {
                return (_openBlock(), _createElementBlock("section", {
                  key: group.category,
                  class: "xyp-service-group"
                }, [
                  _createElementVNode("h3", null, [
                    _createTextVNode(_toDisplayString(group.category) + " ", 1),
                    _createElementVNode("small", null, _toDisplayString(group.items.length), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: item.code,
                      type: "button",
                      class: _normalizeClass({ active: item.code === _ctx.service.code }),
                      onClick: ($event: any) => (_ctx.openService(item.code))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.name), 1),
                      _createElementVNode("small", null, _toDisplayString(item.code), 1)
                    ], 10, _hoisted_12))
                  }), 128))
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("main", _hoisted_13, [
            _createElementVNode("section", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("small", null, _toDisplayString(_ctx.service.inputs.length) + " талбар", 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.service.inputs, (input) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: input.name,
                    class: "xyp-form-field"
                  }, [
                    _createElementVNode("label", null, [
                      (input.required)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "*"))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(input.label), 1)
                    ]),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form[input.name],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form[input.name]) = $event),
                      type: input.type || 'text',
                      clearable: "",
                      size: "small",
                      placeholder: input.label,
                      onKeyup: _withKeys(_ctx.submit, ["enter"])
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "placeholder", "onKeyup"])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  icon: "el-icon-search",
                  size: "small",
                  loading: _ctx.loading,
                  onClick: _ctx.submit
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  icon: "el-icon-refresh-left",
                  onClick: _ctx.clearForm
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("section", _hoisted_22, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  (_ctx.elapsedMs)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_ctx.elapsedMs) + " ms", 1))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.result)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_31))
                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        (_ctx.imageValue)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _createElementVNode("img", {
                                src: `data:image/jpeg;base64,${_ctx.imageValue}`,
                                alt: "Цээж зураг"
                              }, null, 8, _hoisted_35),
                              _hoisted_36
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.responseMeta.result || "Хариу ирлээ"), 1),
                          _createElementVNode("span", null, "Код: " + _toDisplayString(_ctx.responseMeta.resultcode ?? "-"), 1),
                          _createElementVNode("span", null, "Сервис: " + _toDisplayString(_ctx.responseMeta.service || _ctx.service.code), 1)
                        ])
                      ]),
                      _createVNode(_component_xyp_value_renderer, { value: _ctx.resultData }, null, 8, ["value"]),
                      _createElementVNode("details", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("pre", null, _toDisplayString(_ctx.prettyResponse), 1)
                      ])
                    ]))
              ])), [
                [_directive_loading, _ctx.loading]
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _hoisted_41,
          _hoisted_42,
          _createElementVNode("p", null, " Энэ сервис зөвхөн Монголбанкны хэрэглэгч болон " + _toDisplayString(_ctx.xypRole(_ctx.service.code)) + " эрхтэй хүнд нээлттэй. ", 1)
        ]))
  ]))
}